import * as React from "react";
import { forwardRef } from "react";
const UserIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12 12c-1.5646 0-2.83698-1.2664-2.83698-2.82354 0-1.55717 1.27238-2.82353 2.83698-2.82353s2.837 1.26636 2.837 2.82353C14.837 10.7336 13.5646 12 12 12m2.6653.4751c1.1256-.9015 1.7817-2.3591 1.5405-3.95511-.2801-1.85153-1.8277-3.33317-3.6959-3.54917-2.57806-.29859-4.76537 1.69905-4.76537 4.20564 0 1.33414.6213 2.52284 1.59013 3.29864-2.38022.8901-4.11787 2.9802-4.39022 5.8009-.03972.4172.28724.7828.70854.7828.361 0 .66881-.271.70073-.6289.2844-3.1504 2.70789-5.0181 5.64629-5.0181s5.3619 1.8677 5.6463 5.0181c.0319.3579.3397.6289.7007.6289.4213 0 .7483-.3656.7085-.7828-.2723-2.8207-2.0099-4.9108-4.3902-5.8009",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 22.5882c5.8477 0 10.5882-4.7405 10.5882-10.5882 0-5.84772-4.7405-10.58824-10.5882-10.58824C6.15228 1.41176 1.41176 6.15228 1.41176 12c0 5.8477 4.74052 10.5882 10.58824 10.5882M12 24C5.37258 24 0 18.6274 0 12 0 5.37258 5.37258 0 12 0c6.6274 0 12 5.37258 12 12 0 6.6274-5.3726 12-12 12"
}));
const ForwardRef = forwardRef(UserIcon);
export { ForwardRef as UserIcon };